import React from "react";
import FilterBar from "./FilterBar";

//exported for use in /articles/topics/[topic].js
export const publicationsFilterLinks = [
	{ name: "All", link: "/articles" },
	{ name: "Professional Capabilities", link: "/articles/topics/professional-capabilities" },
	{ name: "Self-Management", link: "/articles/topics/self-management" },
	{ name: "Operations and Policy", link: "/articles/topics/operations-and-policy" },
	{ name: "Quality and Risk", link: "/articles/topics/quality-and-risk" },
	{ name: "Strategy and Innovation", link: "/articles/topics/strategy-and-innovation" },
];

export default function ArticlesTopicFilterBar() {
	return <FilterBar filterButtons={publicationsFilterLinks} hideAssessment={true} />;
}
